import { array, object, number, string } from 'valibot';

export const dictionaryScheme = object({
	id: number(),
	name: string(),
	name_short: string(),
	year: number(),
	description: string(),
	slug: string(),
	letters: array(
		object({
			id: number(),
			letter: string(),
			slug: string(),
		}),
	),
	image: string(),
});

export const dictionaryArrayScheme = array(dictionaryScheme);

export const dictionaryAuthorScheme = object({
	id: number(),
	first_name: string(),
	last_name: string(),
	patronymic: string(),
	degree: string(),
	full_name: string(),
	affiliation: string(),
	city: string(),
	country: string(),
	orcid_url: string(),
	elibrary_url: string(),
});

export const dictionaryAuthorArrayScheme = array(dictionaryAuthorScheme);

export const dictionaryNamesScheme = array(
	object({
		id: number(),
		name_short: string(),
	}),
);

// Pages
export const dictionaryPageAuthorScheme = object({
	id: number(),
	authors: dictionaryAuthorArrayScheme,
});

export const dictionaryPageFromEditTeamScheme = object({
	id: number(),
	from_edit_team: string(),
});

export const dictionaryPageFromPublisherScheme = object({
	id: number(),
	from_publisher: string(),
});

export const dictionaryPageShortListScheme = object({
	id: number(),
	short_list: string(),
});
